import { useState } from "react";
import LandingPage from "./LandingPage";

import Terms from "./legal/Terms";
import Privacy from "./legal/Privacy";
import Cookies from "./legal/Cookies";

function App() {
  const [page, setPage] = useState("landing");

  if (page === "terms") return <Terms setPage={setPage} />;
  if (page === "privacy") return <Privacy setPage={setPage} />;
  if (page === "cookies") return <Cookies setPage={setPage} />;

  return <LandingPage setPage={setPage} />;
}

export default App;
